import { render } from "./Item.vue?vue&type=template&id=3be65ef8&scoped=true"
import script from "./Item.vue?vue&type=script&lang=js"
export * from "./Item.vue?vue&type=script&lang=js"

import "./Item.vue?vue&type=style&index=0&id=3be65ef8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3be65ef8"]])

export default __exports__